import * as React from 'react';

import { GetOnlineButton } from '../GetOnlineButton';

interface IPaymentColumnBottomProps {
  isGetOnlineButtonAvailable: boolean;
  mortgagePartnerLink: string;
  onGetOnlineButtonClick: (event: React.MouseEvent) => void;
}

export const PaymentColumnBottom: React.FC<IPaymentColumnBottomProps> = ({
  isGetOnlineButtonAvailable,
  mortgagePartnerLink,
  onGetOnlineButtonClick,
}) => {
  if (isGetOnlineButtonAvailable) {
    return <GetOnlineButton href={mortgagePartnerLink} onClick={onGetOnlineButtonClick} />;
  }

  return null;
};
